import { CompetenceDataService } from './../data-services/competence-data.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class CompetenceBusinessService {
    constructor(private service: CompetenceDataService) {
    }
    
    competenceId:number;
    async getCompetence(status:number): Promise<any> {
        return this.service.getCompetence(status);
    }

    addCompetence(model: any): Promise<any> {
        return this.service.addCompetence(model);
    }
    
    async getCompetenceById(id: any): Promise<any> {
        return this.service.getCompetenceById(id);
    }

    updateCompetence(Model: any): Promise<any> {
        return this.service.updateCompetence(Model);
    }

    deleteCompetence(id: any): Promise<any> {
        return this.service.deleteCompetence(id);
    }
   
}
